import React, { useState } from 'react'
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
  Separator,
} from 'office-ui-fabric-react'
import AddReferencesForm from './AddReferencesForm'
import { ChildProps, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { Reference } from '../../../../Api/references'

interface InputProps {
  previousNode: {
    label: string
    domain?: string
  }
  onNode: (node: Reference) => void
  onClose: () => void
}

interface GqlResponse {
  referencesChains: Array<{
    references: Array<{
      buyerDomain: string
    }>
  }>
}

const gqlQuery = gql`
  query {
    referencesChains {
      references {
        buyerDomain
      }
    }
  }
`

function AddSupplyChainNodeDialogView({
  data,
  previousNode,
  onNode,
  onClose,
}: ChildProps<InputProps, GqlResponse>) {
  const [node, setNode] = useState<Reference | null>(null)
  if (!data || data.loading) {
    return null
  }
  const buyerDomains = unique(
    data.referencesChains!.flatMap((chain) =>
      chain.references.map((ref) => ref.buyerDomain)
    )
  )
  return (
    <Dialog
      hidden={false}
      modalProps={{
        isDarkOverlay: true,
        isBlocking: true,
      }}
      onDismiss={onClose}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title: 'Add Node',
      }}
    >
      <AddReferencesForm
        suggestedBuyerDomains={buyerDomains}
        previousNode={previousNode}
        onReference={(node) => setNode(node)}
      />
      <Separator />
      <DialogFooter>
        <DefaultButton onClick={onClose} text="Cancel" />
        <PrimaryButton
          onClick={() => {
            if (!node) {
              return
            }
            onNode(node)
          }}
          text="Add node"
          disabled={!node}
        />
      </DialogFooter>
    </Dialog>
  )
}

const withGql = graphql<InputProps, GqlResponse>(gqlQuery, {
  options: () => ({}),
})
export const AddSupplyChainNodeDialog = withGql(AddSupplyChainNodeDialogView)

function unique<T>(arr: T[]): T[] {
  return Array.from(new Set(arr))
}
